import { useState, useEffect } from 'react';
// ui
import { Button } from 'src/@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'src/@/components/ui/table';
import { Switch } from 'src/@/components/ui/switch';
import { Badge } from 'src/@/components/ui/badge';
// components
import Iconify from 'src/components/Iconify';
import ModalServicos from './ModalServicos';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
// actions
import v2_actionServicos from 'src/actions/v2/cliente/cadastro/v2_actionServicos';
import v2_actionCriarServico from 'src/actions/v2/cliente/cadastro/v2_actionCriarServico';
import v2_actionEditarServico from 'src/actions/v2/cliente/cadastro/v2_actionEditarServico';
import v2_actionDeletarServico from 'src/actions/v2/cliente/cadastro/v2_actionDeletarServico';

export default function ServicosComponent({ user }) {
    const [openModal, setOpenModal] = useState(false);
    const [modalConfimacao, setModalConfirmacao] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [servicos, setServicos] = useState([]);
    const [serviceId, setServiceId] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const [dataService, setDataService] = useState({
        name: '',
        description: '',
        price: '',
        priceSale: '',
        time: 15,
        sale: false,
        status: false,
        instructions: ''
    });

    const fetchData = async () => {
        try {
            const response = await v2_actionServicos(user.clienteId);
            if (response.status === 200) {
                setServicos(response.data.data || []);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOpenModal = () => {
        setOpenModal(true);
        setIsEdit(false);
        setDataService({
            name: '',
            description: '',
            price: '',
            priceSale: '',
            time: 15,
            sale: false,
            status: true,
            instructions: ''
        });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEdit(false);
        setDataService({
            name: '',
            description: '',
            price: '',
            priceSale: '',
            time: 15,
            sale: false,
            status: false,
            instructions: ''
        });
    };

    const handleOpenEdit = (item) => {
        setDataService({
            name: item.name,
            description: item.description,
            price: item.price,
            priceSale: item.priceSale,
            time: item.time,
            sale: item.sale,
            status: item.status,
            instructions: item.instructions
        });
        setServiceId(item._id);
        setIsEdit(true);
        setOpenModal(true);
    };

    const handleSubmit = async () => {
        try {
            await v2_actionCriarServico(user.clienteId, dataService);
            fetchData();
            handleCloseModal();
        } catch (error) {
            console.log(error);
        }
    };

    const handleEditSubmit = async () => {
        try {
            let data = {
                scope: {
                    ...dataService
                }
            };
            await v2_actionEditarServico(serviceId, data);
            await fetchData();
            handleCloseModal();
            setServiceId(null);
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleDelete = async () => {
        try {
            setLoadingDelete(true);
            await v2_actionDeletarServico(serviceId);
            await fetchData();
            setModalConfirmacao(false);
            setServiceId(null);
            setLoadingDelete(false);
        } catch (error) {
            setLoadingDelete(false);
            console.log('error', error);
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        try {
            let data = {
                scope: {
                    status: !currentStatus
                }
            };
            await v2_actionEditarServico(id, data);
            fetchData();
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleToggleSale = async (id, currentSale) => {
        try {
            let data = {
                scope: {
                    sale: !currentSale
                }
            };
            await v2_actionEditarServico(id, data);
            fetchData();
        } catch (error) {
            console.log(error);
        }
    };

    // Change Handlers
    const changeName = (e) => setDataService((prev) => ({ ...prev, name: e.target.value }));
    const changeDescription = (e) => setDataService((prev) => ({ ...prev, description: e.target.value }));
    const changePrice = (e) => setDataService((prev) => ({ ...prev, price: e.target.value }));
    const changePriceSale = (e) => setDataService((prev) => ({ ...prev, priceSale: e.target.value }));
    const changeTime = (e) => {
        let val = e.target.value;
        if (val < 15) val = 15;
        setDataService((prev) => ({ ...prev, time: val }));
    };
    const changeSale = (val) => setDataService((prev) => ({ ...prev, sale: val }));
    const changeInstructions = (e) => setDataService((prev) => ({ ...prev, instructions: e.target.value }));

    return (
        <div className="flex flex-col h-full w-full gap-6 p-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div>
                    <div className="flex items-center gap-3">
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Serviços</h1>
                        <Badge
                            variant="outline"
                            className="bg-violet-50 text-violet-600 border-violet-200 font-medium"
                        >
                            {servicos.length} Serviços
                        </Badge>
                    </div>
                    <p className="text-sm text-gray-500 mt-1">Cadastre serviços oferecidos pela sua empresa</p>
                </div>
                <div className="flex gap-2">
                    <Button
                        onClick={handleOpenModal}
                        className="flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
                    >
                        <Iconify icon="solar:add-circle-bold" className="w-5 h-5" />
                        Novo serviço
                    </Button>
                </div>
            </div>

            {servicos.length === 0 ? (
                <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-gray-100 border-dashed text-center">
                    <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 text-gray-400">
                        <Iconify icon="solar:box-minimalistic-bold-duotone" className="w-8 h-8" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Nenhum serviço encontrado</h3>
                    <p className="text-gray-500 max-w-sm mb-6">Cadastre seus serviços para começar.</p>
                    <Button
                        variant="ghost"
                        className="text-[#7C3AED] font-medium hover:underline text-sm"
                        onClick={handleOpenModal}
                    >
                        Criar meu primeiro serviço
                    </Button>
                </div>
            ) : (
                <div className="rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm">
                    <Table>
                        <TableHeader className="bg-gray-50">
                            <TableRow>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Nome</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Tempo</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Preço</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Preço Promo</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Promoção</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</TableHead>
                                <TableHead className="text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Ações</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {servicos.map((row) => (
                                <TableRow key={row._id} className="hover:bg-gray-50 transition-colors">
                                    <TableCell className="font-medium text-gray-900">{row.name}</TableCell>
                                    <TableCell className="text-gray-600">{row.time} min</TableCell>
                                    <TableCell className="text-gray-600">R$ {row.price}</TableCell>
                                    <TableCell className="text-green-600 font-medium">
                                        {row.priceSale ? `R$ ${row.priceSale}` : '-'}
                                    </TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={row.sale}
                                            onCheckedChange={() => handleToggleSale(row._id, row.sale)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={row.status}
                                            onCheckedChange={() => handleToggleStatus(row._id, row.status)}
                                        />
                                    </TableCell>
                                    <TableCell className="text-right">
                                        <div className="flex justify-end gap-2">
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="h-8 w-8 p-0 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                                                onClick={() => handleOpenEdit(row)}
                                            >
                                                <Iconify icon="solar:pen-bold" className="w-4 h-4" />
                                            </Button>
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="h-8 w-8 p-0 text-red-600 hover:text-red-700 hover:bg-red-50"
                                                onClick={() => {
                                                    setServiceId(row._id);
                                                    setModalConfirmacao(true);
                                                }}
                                            >
                                                <Iconify icon="solar:trash-bin-trash-bold" className="w-4 h-4" />
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}

            <ModalConfimacao
                open={modalConfimacao}
                onClose={() => {
                    setModalConfirmacao(false);
                    setServiceId(null);
                }}
                onConfirm={handleDelete}
                loadingFinalizar={loadingDelete}
                mensagem={'Deseja mesmo excluir?'}
            />

            <ModalServicos
                open={openModal}
                onClose={handleCloseModal}
                dataService={dataService}
                isEdit={isEdit}
                changeName={changeName}
                changeDescription={changeDescription}
                changePrice={changePrice}
                changePriceSale={changePriceSale}
                changeTime={changeTime}
                changeSale={changeSale}
                changeInstructions={changeInstructions}
                onSubmit={handleSubmit}
                onEdit={handleEditSubmit}
            />
        </div>
    );
}
